// @noflow
import './styles.css';

import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import messages from './intl';
import { momentObj } from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

const LogsInfoPropTypes = {
    durationMessage: PropTypes.string,
    inMotion: PropTypes.bool,
    label: PropTypes.string.isRequired,
    showMultipleEvents: PropTypes.bool,
    simpleMergedLabel: PropTypes.bool,
    style: PropTypes.shape({
        right: PropTypes.string.isRequired,
        zIndex: PropTypes.number.isRequired
    }),
    timeToDisplay: momentObj
};

const LogsInfo = ({
    style,
    durationMessage,
    inMotion,
    label,
    showMultipleEvents,
    simpleMergedLabel,
    timeToDisplay
}) => (
    <div className="logs-timeline-component__info" style={style}>
        <div className="logs-timeline-component__info-wrapper">
            <div
                className={classnames('logs-timeline-component__info-text', {
                    'logs-timeline-component__info-text--in-motion': !durationMessage
                })}
            >
                <div>
                    {inMotion ? (
                        <FormattedMessage {...messages.motionDetected} />
                    ) : simpleMergedLabel && showMultipleEvents ? (
                        <span>{durationMessage}</span>
                    ) : (
                        <FormattedMessage {...messages[label]} />
                    )}
                    <br />
                    {durationMessage &&
                        !simpleMergedLabel && (
                            <span className="logs-timeline-component__info-duration">({durationMessage})</span>
                        )}
                </div>
                {timeToDisplay && timeToDisplay.format('LT')}
            </div>
        </div>
    </div>
);

LogsInfo.propTypes = LogsInfoPropTypes;
export default LogsInfo;



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/logs/info/index.js